(function () {
  'use strict';

  var NOTICE_DISMISSED_KEY = 'iurop:threshold-gift:notice-dismissed';
  var NOTICE_LAST_SHOWN_KEY = 'iurop:threshold-gift:notice-last-shown';
  var NEWSLETTER_PENDING_KEY = 'iurop:threshold-gift:newsletter-pending';
  var REWARD_DISMISSED_KEY = 'iurop:threshold-gift:reward-dismissed';
  var PROMO_PROPERTY = '_iurop_promo_gift';
  var GIFT_PROPERTY = '_regalo';
  var CAMPAIGN_ATTRIBUTE = 'iurop_threshold_gift_campaign__';
  var busy = false;
  var noticeTimer = null;
  var noticeRepeatTimer = null;
  var noticeShownThisPage = false;
  var noticeLastShown = 0;
  var newsletterResultActive = false;
  var rewardTimer = null;
  var currentCart = null;
  var checkoutPending = false;
  var checkoutCheckBusy = false;

  function campaign() {
    return document.querySelector('[data-threshold-gift-campaign]');
  }

  function campaignState() {
    return document.querySelector('[data-threshold-gift-state]');
  }

  function noticePopup() {
    return document.querySelector('[data-threshold-gift-notice]');
  }

  function rewardPopup() {
    return document.querySelector('[data-threshold-gift-popup]');
  }

  function isPromoGift(item, promoKey) {
    return Boolean(item && item.properties && item.properties[PROMO_PROPERTY] === promoKey);
  }

  function qualifyingSubtotal(cart, promoKey) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (total, item) {
      if (isPromoGift(item, promoKey)) return total;
      var lineTotal = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
      return total + (lineTotal || 0);
    }, 0);
  }

  function giftInCart(cart, promoKey) {
    return Boolean(cart && cart.items && cart.items.some(function (item) {
      return isPromoGift(item, promoKey);
    }));
  }

  function promoGift(cart, promoKey) {
    if (!cart || !cart.items) return null;
    return cart.items.find(function (item) { return isPromoGift(item, promoKey); }) || null;
  }

  function hasAvailableGift() {
    var reward = rewardPopup();
    return Boolean(reward && reward.querySelector('[data-threshold-gift-option]:not(:disabled)'));
  }

  function needsGiftSelection(cart) {
    var node = campaign();
    if (!node || node.dataset.enabled !== 'true' || !hasAvailableGift()) return false;
    var promoKey = node.dataset.promoKey;
    var threshold = parseInt(node.dataset.thresholdCents, 10) || 12900;
    return !giftInCart(cart, promoKey) && qualifyingSubtotal(cart, promoKey) >= threshold;
  }

  function storageHas(key) {
    try { return sessionStorage.getItem(key) === '1'; } catch (_) { return false; }
  }

  function storageSet(key) {
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  }

  function storageRemove(key) {
    try { sessionStorage.removeItem(key); } catch (_) {}
  }

  function noticeFrequency() {
    var node = campaign();
    var frequency = node && node.dataset.noticeFrequency;
    return ['day', 'interval', 'always'].indexOf(frequency) !== -1 ? frequency : 'session';
  }

  function noticeInterval() {
    var frequency = noticeFrequency();
    if (frequency === 'day') return 24 * 60 * 60 * 1000;
    if (frequency !== 'interval') return 0;
    var hours = parseInt(campaign().dataset.noticeIntervalHours, 10) || 6;
    return Math.max(1, Math.min(24, hours)) * 60 * 60 * 1000;
  }

  function noticeRemaining() {
    var lastShown = noticeLastShown;
    try { lastShown = Math.max(lastShown, Number(localStorage.getItem(NOTICE_LAST_SHOWN_KEY)) || 0); } catch (_) {}
    return lastShown ? Math.max(0, lastShown + noticeInterval() - Date.now()) : 0;
  }

  function noticeAllowed() {
    var frequency = noticeFrequency();
    if (frequency === 'session') return !noticeShownThisPage && !storageHas(NOTICE_DISMISSED_KEY);
    if (frequency === 'always') return !noticeShownThisPage;
    return noticeRemaining() === 0;
  }

  function markNoticeShown() {
    noticeShownThisPage = true;
    noticeLastShown = Date.now();
    if (noticeFrequency() === 'session') storageSet(NOTICE_DISMISSED_KEY);
    try { localStorage.setItem(NOTICE_LAST_SHOWN_KEY, String(noticeLastShown)); } catch (_) {}
  }

  function scheduleNoticeRepeat() {
    if (!noticeInterval() || noticeRepeatTimer) return;
    noticeRepeatTimer = window.setTimeout(function () {
      noticeRepeatTimer = null;
      fetchCart().then(evaluate).catch(function () {});
    }, Math.max(1000, noticeRemaining()));
  }

  function showNewsletterResult() {
    var notice = noticePopup();
    var result = notice && notice.querySelector('[data-threshold-newsletter-result]');
    if (!result) return;
    var pending = 0;
    try { pending = Number(sessionStorage.getItem(NEWSLETTER_PENDING_KEY)) || 0; } catch (_) {}
    var returnedToForm = window.location.hash === '#iurop-threshold-gift-newsletter';
    if (!returnedToForm && !(pending && Date.now() - pending < 15 * 60 * 1000)) return;
    storageRemove(NEWSLETTER_PENDING_KEY);
    result.hidden = false;
    var fields = notice.querySelector('[data-threshold-newsletter-fields]');
    if (fields && result.dataset.thresholdNewsletterResult === 'success') fields.hidden = true;
    newsletterResultActive = true;
    openPopup(notice, 'notice');
    result.focus({ preventScroll: true });
  }

  function clearTimer(type) {
    if (type === 'notice' && noticeRepeatTimer) {
      window.clearTimeout(noticeRepeatTimer);
      noticeRepeatTimer = null;
    }
    if (type === 'notice' && noticeTimer) {
      window.clearTimeout(noticeTimer);
      noticeTimer = null;
    }
    if (type === 'reward' && rewardTimer) {
      window.clearTimeout(rewardTimer);
      rewardTimer = null;
    }
  }

  function syncBodyLock() {
    var hasOpenPopup = document.querySelector('.apodemia-threshold-gift.is-open');
    document.body.classList.toggle('apodemia-threshold-gift-open', Boolean(hasOpenPopup));
  }

  function openPopup(node, type) {
    if (!node || node.classList.contains('is-open')) return;
    var other = type === 'notice' ? rewardPopup() : noticePopup();
    if (other) closePopup(other, type === 'notice' ? 'reward' : 'notice', false);
    node.classList.add('is-open');
    node.setAttribute('aria-hidden', 'false');
    node.removeAttribute('inert');
    if (type === 'notice') markNoticeShown();
    syncBodyLock();
    var focusTarget = type === 'reward'
      ? node.querySelector('[data-threshold-gift-option]:not(:disabled)')
      : node.querySelector('[data-threshold-gift-notice-accept]');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function closePopup(node, type, remember) {
    if (!node) return;
    clearTimer(type);
    node.classList.remove('is-open');
    node.setAttribute('aria-hidden', 'true');
    node.setAttribute('inert', '');
    if (type === 'notice') newsletterResultActive = false;
    if (remember !== false) {
      if (type === 'notice') {
        scheduleNoticeRepeat();
      } else {
        storageSet(REWARD_DISMISSED_KEY);
      }
      if (type === 'reward') checkoutPending = false;
    }
    syncBodyLock();
  }

  function schedulePopup(type, delaySeconds) {
    var node = type === 'notice' ? noticePopup() : rewardPopup();
    var existingTimer = type === 'notice' ? noticeTimer : rewardTimer;
    if (!node || existingTimer || node.classList.contains('is-open')) return;
    var timer = window.setTimeout(function () {
      if (type === 'notice') noticeTimer = null;
      else rewardTimer = null;
      if (type === 'notice' && !noticeAllowed()) {
        scheduleNoticeRepeat();
        return;
      }
      openPopup(node, type);
    }, Math.max(0, delaySeconds) * 1000);
    if (type === 'notice') noticeTimer = timer;
    else rewardTimer = timer;
  }

  function removeGift(item) {
    if (!item || busy) return;
    busy = true;
    storageRemove(REWARD_DISMISSED_KEY);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('remove');
        return response.json();
      })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function evaluate(cart) {
    currentCart = cart;
    var node = campaign();
    if (!node || node.dataset.enabled !== 'true') return;
    var promoKey = node.dataset.promoKey;
    var threshold = parseInt(node.dataset.thresholdCents, 10) || 12900;
    var gift = promoGift(cart, promoKey);
    var subtotal = qualifyingSubtotal(cart, promoKey);

    if (newsletterResultActive) {
      if (gift && subtotal < threshold) removeGift(gift);
      return;
    }

    if (gift && subtotal < threshold) {
      closePopup(noticePopup(), 'notice', false);
      closePopup(rewardPopup(), 'reward', false);
      removeGift(gift);
      return;
    }

    if (gift) {
      closePopup(noticePopup(), 'notice', false);
      closePopup(rewardPopup(), 'reward', false);
      return;
    }

    if (subtotal >= threshold) {
      storageSet(NOTICE_DISMISSED_KEY);
      closePopup(noticePopup(), 'notice', false);
      if (storageHas(REWARD_DISMISSED_KEY)) {
        closePopup(rewardPopup(), 'reward', false);
        return;
      }
      schedulePopup('reward', parseInt(node.dataset.rewardDelay, 10) || 0);
      return;
    }

    closePopup(rewardPopup(), 'reward', false);
    if (noticePopup().classList.contains('is-open')) return;
    if (!noticeAllowed()) {
      closePopup(noticePopup(), 'notice', false);
      scheduleNoticeRepeat();
      return;
    }
    schedulePopup('notice', parseInt(node.dataset.noticeDelay, 10) || 0);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      });
  }

  function syncCampaignAttribute(cart) {
    var state = campaignState();
    if (!state || !cart) return Promise.resolve(cart);
    var desiredValue = state.dataset.enabled === 'true' ? state.dataset.promoKey : '';
    var currentValue = cart.attributes && cart.attributes[CAMPAIGN_ATTRIBUTE] || '';
    if (currentValue === desiredValue) return Promise.resolve(cart);

    var attributes = {};
    attributes[CAMPAIGN_ATTRIBUTE] = desiredValue;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('campaign-attribute');
      return response.json();
    });
  }

  function setMessage(key) {
    var node = campaign();
    var reward = rewardPopup();
    var message = reward && reward.querySelector('[data-threshold-gift-message]');
    if (!message) return;
    message.textContent = key === 'error'
      ? node.dataset.error || 'No hemos podido añadir el regalo. Inténtalo de nuevo.'
      : '';
  }

  function addGift() {
    var node = campaign();
    var reward = rewardPopup();
    if (!node || !reward || busy) return;
    var selected = reward.querySelector('[data-threshold-gift-option]:checked');
    var button = reward.querySelector('[data-threshold-gift-add]');
    var variantId = selected && parseInt(selected.value, 10);
    if (!variantId) return;

    busy = true;
    button.disabled = true;
    reward.setAttribute('data-busy', 'true');
    setMessage('');

    fetchCart()
      .then(function (cart) {
        var threshold = parseInt(node.dataset.thresholdCents, 10) || 12900;
        if (giftInCart(cart, node.dataset.promoKey) || qualifyingSubtotal(cart, node.dataset.promoKey) < threshold) {
          throw new Error('ineligible');
        }
        var properties = {};
        properties[PROMO_PROPERTY] = node.dataset.promoKey;
        properties[GIFT_PROPERTY] = node.dataset.giftLabel || 'Regalo por compra';
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('add');
        return fetchCart();
      })
      .then(function (cart) {
        currentCart = cart;
        storageSet(REWARD_DISMISSED_KEY);
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
        closePopup(reward, 'reward', false);
        if (checkoutPending) {
          checkoutPending = false;
          window.location.assign('/checkout');
        }
      })
      .catch(function () {
        setMessage('error');
        button.disabled = false;
      })
      .then(function () {
        busy = false;
        reward.removeAttribute('data-busy');
      });
  }

  function openRewardForCheckout() {
    checkoutPending = true;
    clearTimer('notice');
    clearTimer('reward');
    storageSet(NOTICE_DISMISSED_KEY);
    storageRemove(REWARD_DISMISSED_KEY);
    closePopup(noticePopup(), 'notice', false);
    setMessage('');
    openPopup(rewardPopup(), 'reward');
  }

  function continueToCheckout() {
    checkoutPending = false;
    window.location.assign('/checkout');
  }

  function retryCheckoutFromCart() {
    checkoutPending = false;
    if (window.location.pathname === '/cart') window.location.reload();
    else window.location.assign('/cart');
  }

  function stopCheckout(event) {
    var node = campaign();
    if (!node || node.dataset.enabled !== 'true' || !hasAvailableGift()) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    if (checkoutCheckBusy) return;

    checkoutCheckBusy = true;
    fetchCart()
      .then(function (cart) {
        currentCart = cart;
        if (needsGiftSelection(cart)) {
          openRewardForCheckout();
          return;
        }
        continueToCheckout();
      })
      .catch(function () {
        retryCheckoutFromCart();
      })
      .then(function () {
        checkoutCheckBusy = false;
      });
  }

  function bindCheckoutGate() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var control = target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (!control) return;
      stopCheckout(event);
    }, true);

    document.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      var form = event.target;
      var isCheckoutSubmit = Boolean(
        (submitter && submitter.name === 'checkout') ||
        (form && typeof form.getAttribute === 'function' && /\/checkout(?:[/?#]|$)/.test(form.getAttribute('action') || ''))
      );
      if (!isCheckoutSubmit) return;
      stopCheckout(event);
    }, true);
  }

  function bind() {
    var node = campaign();
    var notice = noticePopup();
    var reward = rewardPopup();
    if (!node || !notice || !reward) return;

    notice.querySelectorAll('[data-threshold-gift-notice-close]').forEach(function (button) {
      button.addEventListener('click', function () { closePopup(notice, 'notice', true); });
    });
    var noticeAccept = notice.querySelector('[data-threshold-gift-notice-accept]');
    if (noticeAccept) {
      noticeAccept.addEventListener('click', function () { closePopup(notice, 'notice', true); });
    }
    var newsletter = notice.querySelector('[data-threshold-newsletter]');
    if (newsletter) {
      newsletter.addEventListener('submit', function () {
        try { sessionStorage.setItem(NEWSLETTER_PENDING_KEY, String(Date.now())); } catch (_) {}
      });
    }
    reward.querySelectorAll('[data-threshold-gift-reward-close]').forEach(function (button) {
      button.addEventListener('click', function () { closePopup(reward, 'reward', true); });
    });
    reward.querySelectorAll('[data-threshold-gift-option]').forEach(function (option) {
      option.addEventListener('change', function () {
        var button = reward.querySelector('[data-threshold-gift-add]');
        if (button) button.disabled = false;
        setMessage('');
      });
    });
    var addButton = reward.querySelector('[data-threshold-gift-add]');
    if (addButton) addButton.addEventListener('click', addGift);

    bindCheckoutGate();

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (notice.classList.contains('is-open')) closePopup(notice, 'notice', true);
      if (reward.classList.contains('is-open')) closePopup(reward, 'reward', true);
    });
    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart) evaluate(cart);
      else fetchCart().then(evaluate).catch(function () {});
    });
  }

  function init() {
    if (!campaignState()) return;
    if (campaign()) bind();
    if (campaign()) showNewsletterResult();
    fetchCart()
      .then(syncCampaignAttribute)
      .then(function (cart) {
        if (campaign()) evaluate(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.iuropThresholdGift = {
    showNotice: function () { openPopup(noticePopup(), 'notice'); },
    showReward: function () { openPopup(rewardPopup(), 'reward'); },
    close: function () {
      closePopup(noticePopup(), 'notice', false);
      closePopup(rewardPopup(), 'reward', false);
    },
    reset: function () {
      clearTimer('notice');
      noticeShownThisPage = false;
      noticeLastShown = 0;
      newsletterResultActive = false;
      try { localStorage.removeItem(NOTICE_LAST_SHOWN_KEY); } catch (_) {}
      storageRemove(NOTICE_DISMISSED_KEY);
      storageRemove(REWARD_DISMISSED_KEY);
      fetchCart().then(evaluate).catch(function () {});
    },
    qualifyingSubtotal: qualifyingSubtotal
  };
})();
